import { TableCellModel } from "./tablecell.model";
import { UUID } from 'angular2-uuid';

export class TableRowModel {
  uuid: string;
  firstcell: string;
  secondcell: string;
  thirdcell: string;
  cells: string[];
  orderedcells: TableCellModel[];
  relatedModels: string;
  firstcellLinkText: string;

  constructor() {
    this.uuid =  UUID.UUID();
    this.cells = [];
    this.orderedcells = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/models/tablerow.model.ts